import { getUserManager } from "../oidc/userManager";

/**
 * Returns the OIDC access token, attempting silent renew if expired.
 */
export async function getAccessToken() {
  const um = getUserManager();
  let user = await um.getUser();
  if (!user) {
    return null;
  }
  if (user.expired) {
    try {
      user = await um.signinSilent();
    } catch {
      return null;
    }
  }
  return user?.access_token ?? null;
}
